import {Component} from '@angular/core';
import {stepperConfig} from '../config/import/stepper-config';
import {fieldsToImportConfig} from '../config/import/fields-to-import-config';
import {StepperReadyEvent} from '../../../../projects/mydocma/import-export/src/lib/stepper/events/stepper-ready.event';
import {SelectItem} from '../../../../projects/mydocma/import-export/src/lib/import/models/select-item';
import {StepperConfig} from '../../../../projects/mydocma/import-export/src/lib/stepper/stepper.config';
import {ImportConfig} from '../../../../projects/mydocma/import-export/src/lib/import/configs/import.config';
import {ExecutionItem} from '../../../../projects/mydocma/import-export/src/lib/stepper/execution/execution-item';
import {ExecutionStateEnum} from '../../../../projects/mydocma/import-export/src/lib/stepper/execution/execution-state.enum';

@Component({
    selector: 'app-import-stepper',
    templateUrl: './app-import-stepper.component.html',
    styleUrls: ['./app-import-stepper.component.scss']
})
export class AppImportStepperComponent {

    public stepperConfig: StepperConfig = stepperConfig;

    public fieldsToImportConfig: ImportConfig = fieldsToImportConfig;

    public stepperData: StepperReadyEvent;

    public items = [
        new ExecutionItem({
            name: 'import',
            text: 'Import is in progress...',
            icon: 'done',
            progress: 30
        })
    ];

    public onReadyEvent(param: StepperReadyEvent) {
        this.stepperData = param;

        this.stepperConfig.validate = (currStep) => {
            if (currStep.index >= 2) {
                return;
            }

            this.stepperData.executionService.end();
            this.items[0].text = 'Import is in progress...';
            this.items[0].state = ExecutionStateEnum.NotStarted;

            const step = this.stepperData.stepperService.getStepByIndex(currStep.index + 1);
            if (!step.completed) {
                return;
            }

            this.setStepData(step, {error: null, valid: false, data: null});
        };
    }

    public onImportEvent() {
        this.stepperData.executionService.start(this.items);

        setTimeout(() => {
            this.items[0].text = 'Import was successful';
            this.items[0].state = ExecutionStateEnum.Completed;
        }, 3000);
    }

    public getSrc(): Promise<SelectItem[]> {
        return Promise.resolve([
            {id: 1, text: 'Lviv'},
            {id: 2, text: 'Tallinn'},
            {id: 3, text: 'Canada'}
        ]);
    }

    private setStepData(step, stepData) {
        this.stepperData.stepperService.setStepData(step, stepData, false);

        if (step.index < 3) {
            const stepByIndex = this.stepperData.stepperService.getStepByIndex(step.index + 1);
            this.setStepData(stepByIndex, {error: null, valid: false, data: null});
        }
    }
}

